module.exports = __webpack_public_path__ + "static/djar-new-2c13e425007e6c51ed4241503bd7b7ad.png";